import React from 'react'
import axios from 'axios'

const initialState = {
    user: {
        matricula: localStorage.matricula,
        estado: ''
    }
}

export default class Estado extends React.Component {
    constructor(props) {
        super(props)
        this.state = { ...initialState }
    }

    updateField(event) {
        const user = { ...this.state.user }
        user[event.target.name] = event.target.value
        this.setState({ user })
    }

    salvar() {
        const url = '/api/user/estado'
        const user = { ...this.state.user }
        axios.put(url, user)
            .then(res => {
                localStorage.setItem('estado', this.state.user.estado)
                return window.location = "/"
            })
            .catch(error => {
                alert(error)
            })
    }

    render() {
        return (
            <div className="col-md-4 col-sm-12 mx-auto">
                <div className="form-group row">
                    <label className="col-md-3 mt-5">Estado:</label>
                    <div className="col-md-8 mt-5">
                        <select className="custom-select"
                            name="estado"
                            value={this.state.user.estado}
                            onChange={e => this.updateField(e)} >
                            <option value=""></option>
                            <option value="AL">Alagoas</option>
                            <option value="PB">Paraíba</option>
                            <option value="PE">Pernambuco</option>
                            <option value="RN">Rio Grande do Norte</option>
                        </select>
                    </div>
                </div>
                    <div className="text-center mt-5">
                        <button className="btn btnColor" onClick={e => this.salvar()}>Salvar</button>
                    </div>
            </div>
        )
    }
}